import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { FaRegClock } from "react-icons/fa";
import { GiPartyPopper } from "react-icons/gi";

// Animation pour le texte
const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;
// Animation flottante (logo qui bouge doucement)
const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

// Conteneur principal
const CountdownWrapper = styled.div`
  background: url('/Assets/background.JPG') center/contain no-repeat;
  background-color: white;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: black;
  text-align: center;
  position: relative;

  /* Desktop */
  @media (min-width: 768px) {
    background-size: cover;
    background-position: center;
  }
`;



// Overlay sombre
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.6); /* voile blanc clair */
  z-index: 1;
`;

// Contenu
const Content = styled.div`
  position: relative;
  z-index: 2;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// Logo
const Logo = styled.img`
  width: 120px;
  height: auto;
  margin-bottom: 20px;
  animation: ${float} 3s ease-in-out infinite;


  @media (max-width: 768px) {
    width: 90px;
  }

  @media (max-width: 480px) {
    width: 70px;
  }
`;

// Titre animé
const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 40px;
  animation: ${pulse} 2s infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
    flex-direction: column;
  }
`;

// Timer
const Timer = styled.div`
  display: flex;
  gap: 20px;
  font-size: 2rem;
  font-weight: bold;

  @media (max-width: 768px) {
    gap: 15px;
    font-size: 1.5rem;
    flex-wrap: wrap;
    justify-content: center;
  }

  @media (max-width: 480px) {
    gap: 10px;
    font-size: 1.2rem;
  }
`;

// Boîte de temps
const TimeBox = styled.div`
  background: rgba(255, 255, 255, 0.2);
  padding: 20px;
  border-radius: 15px;
  min-width: 100px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);

  @media (max-width: 768px) {
    min-width: 80px;
    padding: 15px;
  }

  @media (max-width: 480px) {
    min-width: 70px;
    padding: 10px;
  }
`;

// Label
const Label = styled.div`
  font-size: 1rem;
  margin-top: 10px;
  text-transform: uppercase;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }

  @media (max-width: 480px) {
    font-size: 0.7rem;
  }
`;

const Countdown = () => {
    const [timeLeft, setTimeLeft] = useState({});

    useEffect(() => {
        const targetDate = new Date("2026-02-07T00:00:00").getTime();

        const interval = setInterval(() => {
            const now = new Date().getTime();
            const distance = targetDate - now;

            if (distance <= 0) {
                clearInterval(interval);
                setTimeLeft({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                });
            } else {
                setTimeLeft({
                    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
                    hours: Math.floor(
                        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                    ),
                    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds: Math.floor((distance % (1000 * 60)) / 1000),
                });
            }
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <CountdownWrapper>
            <Overlay />
            <Content>
                {/* Ton logo au-dessus */}
                <Logo src="/logo.png" alt="Logo" />

                <Title>
                    <GiPartyPopper /> Compte à rebours  <FaRegClock />
                </Title>

                <Timer>
                    <TimeBox>
                        {timeLeft.days}
                        <Label>Jours</Label>
                    </TimeBox>
                    <TimeBox>
                        {timeLeft.hours}
                        <Label>Heures</Label>
                    </TimeBox>
                    <TimeBox>
                        {timeLeft.minutes}
                        <Label>Minutes</Label>
                    </TimeBox>
                    <TimeBox>
                        {timeLeft.seconds}
                        <Label>Secondes</Label>
                    </TimeBox>
                </Timer>
            </Content>
        </CountdownWrapper>
    );
};

export default Countdown;
